/*
*
* Version : 1.0.0
* 04/09/2016 - 10h18
*
*! Octave Web7 !*/

/*
 * angular-lazy-load
 *
 * Copyright(c) 2014 Paweł Wszoła <wszola.p@gmail.com>
 * MIT Licensed
 * @author Paweł Wszoła (wszola.p@gmail.com)
 * https://github.com/Pentiado/angular-lazy-img
 */

angular
  .module('module.lazy-img', [])

  /* @ngInject */
  .factory('LazyImgMagic', ["$window", "$rootScope", "lazyImgConfig", "lazyImgHelpers", function ($window, $rootScope, lazyImgConfig, lazyImgHelpers) {
    'use strict';

    var winDimensions, $win, images, isListening, options;
    var checkImagesT, saveWinOffsetT, containers;

    images = [];
    isListening = false;
    options = lazyImgConfig.getOptions();
    $win = angular.element($window);
    winDimensions = lazyImgHelpers.getWinDimensions();
    saveWinOffsetT = lazyImgHelpers.throttle(function () {
      winDimensions = lazyImgHelpers.getWinDimensions();
    }, 60);
    containers = [options.container || $win];

    function checkImages() {
      for (var i = images.length - 1; i >= 0; i--) {
        var image = images[i];

        if (image) {
          var _isInView = !image.$elem.is(':visible') ? false : lazyImgHelpers.isElementInView(image.$elem[0], options.offset, winDimensions);
          if (_isInView) {
            loadImage(image);
            images.splice(i, 1);
          }
        }
      }
      if (images.length === 0) stopListening();
    }

    checkImagesT = lazyImgHelpers.throttle(checkImages, 30);

    function listen(param) {
      containers.forEach(function (container) {
        container[param]('scroll', checkImagesT);
        container[param]('touchmove', checkImagesT);
      });
      $win[param]('resize', checkImagesT);
      $win[param]('resize', saveWinOffsetT);
    }

    function startListening() {
      isListening = true;
      setTimeout(function () {
        checkImages();
        listen('on');
      }, 1);
    }

    function stopListening() {
      isListening = false;
      listen('off');
    }

    function removeImage(image) {
      var index = images.indexOf(image);
      if (index !== -1) {
        images.splice(index, 1);
      }
    }

    function loadImage(photo) {
      if (photo.loaded || photo.src === '') return;
      if (photo.addClassToParent) {
        photo.$elem.parent().removeClass(options.successClass);
      }
      var img = new Image();
      img.onerror = function () {
        if (options.errorClass) {
          photo.$elem.addClass(options.errorClass);
        }
        $rootScope.$emit('lazyImg:error', photo);
        options.onError(photo);
      };
      img.onload = function () {
        photo.loaded = true;
        setPhotoSrc(photo.$elem, photo.src, photo.srcset);
        if (options.loadingClass) {
          photo.$elem.removeClass(options.loadingClass);
        }
        if (options.successClass) {
          photo.$elem.addClass(options.successClass);
          if (photo.addClassToParent) {
            photo.$elem.parent().addClass(options.successClass);
          }
        }
        if (typeof photo.spinner !== 'undefined') {
          stopSpinner(photo);
        }
        $rootScope.$emit('lazyImg:success', photo);
        options.onSuccess(photo);
      };
      if (options.loadingClass) {
        photo.$elem.addClass(options.loadingClass);
      }
      options.onLoading(photo);

      if (typeof photo.spinner !== 'undefined') {
        startSpinner(photo);
      }

      img.src = photo.src;
    }

    function startSpinner(photo) {
      var spinner = photo.spinner;
      $(spinner.el).removeClass('out');
      spinner.spin(photo.$elem.parent()[0]);
      setTimeout(function () {
        $(spinner.el).addClass('in');
      });
    }
    function stopSpinner(photo) {
      var spinner = photo.spinner;
      $(spinner.el).removeClass('in').addClass('out');
      setTimeout(function () {
        spinner.stop();
        photo.spinner = null;
      }, spinner.delay);
    }

    function setPhotoSrc($elem, src, srcset) {
      if ($elem[0].nodeName.toLowerCase() === 'img') {
        $elem[0].src = src;
        if (srcset) {
          $elem[0].srcset = srcset;
        }
      } else {
        $elem.css('background-image', 'url("' + src + '")');
      }
    }

    // PHOTO
    function Photo($elem) {
      this.$elem = $elem;
    }

    Photo.prototype.setAddClassToParent = function () {
      this.addClassToParent = true;
    };

    Photo.prototype.setSpinner = function (spinner) {
      this.spinner = spinner;
    };

    Photo.prototype.setSource = function (source) {
      this.src = source;
      images.unshift(this);
      if (!isListening) { startListening(); }
      if (images.length !== 1) {
        setTimeout(function () {
          checkImages();
        }, 1);
      }
    };

    Photo.prototype.removeImage = function () {
      removeImage(this);
      if (images.length === 0) stopListening();
    };

    Photo.prototype.checkImages = function () {
      checkImages();
    };

    Photo.addContainer = function (container) {
      stopListening();
      containers.push(container);
      startListening();
    };

    Photo.removeContainer = function (container) {
      stopListening();
      containers.splice(containers.indexOf(container), 1);
      startListening();
    };

    return Photo;

  }])

  /* @ngInject */
  .provider('lazyImgConfig', function () {
    'use strict';

    this.options = {
      offset: 100,
      errorClass: null,
      loadingClass: null,
      successClass: null,
      onError: function () {},
      onLoading: function () {},
      onSuccess: function () {}
    };

    this.$get = function () {
      var options = this.options;
      return {
        getOptions: function () {
          return options;
        }
      };
    };

    this.setOptions = function (options) {
      angular.extend(this.options, options);
    };
  })

  /* @ngInject */
  .factory('lazyImgHelpers', ["$window", function ($window) {
    'use strict';

    function getWinDimensions() {
      return {
        height: $window.innerHeight,
        width: $window.innerWidth
      };
    }

    function isElementInView(elem, offset, winDimensions) {
      var rect = elem.getBoundingClientRect();
      var bottomline = winDimensions.height + offset;
      return (
        rect.left >= 0 && rect.right <= winDimensions.width + offset && (
          rect.top >= 0 && rect.top <= bottomline ||
          rect.bottom <= bottomline && rect.bottom >= 0 - offset
        )
      );
    }

    // http://remysharp.com/2010/07/21/throttling-function-calls/
    function throttle(fn, threshhold, scope) {
      var last, deferTimer;
      return function () {
        var context = scope || this;
        var now = +new Date(),
          args = arguments;
        if (last && now < last + threshhold) {
          clearTimeout(deferTimer);
          deferTimer = setTimeout(function () {
            last = now;
            fn.apply(context, args);
          }, threshhold);
        } else {
          last = now;
          fn.apply(context, args);
        }
      };
    }

    return {
      isElementInView: isElementInView,
      getWinDimensions: getWinDimensions,
      throttle: throttle
    };

  }])

  /* @ngInject */
  .directive('lazyImg', ["$rootScope", "LazyImgMagic", "usSpinnerConfig", function ($rootScope, LazyImgMagic, usSpinnerConfig) {
    'use strict';

    function link(scope, element, attrs) {

      if (angular.isDefined(attrs.lazyIf) && attrs.lazyIf === 'false') {
        return;
      }

      var lazyImage = new LazyImgMagic(element);

      if (angular.isDefined(attrs.parentLoadedClass)) {
        lazyImage.setAddClassToParent();
      }

      var deregister = attrs.$observe('lazyImg', function (newSource) {
        if (newSource && newSource !== '') {
          deregister();
          lazyImage.setSource(newSource);
        }
      });

      // Spinner
      if (!angular.isDefined(attrs.noSpinner)) {
        var theme = angular.isDefined(attrs.spinnerTheme) ? attrs.spinnerTheme : 'small';
        var options = angular.extend({},
            usSpinnerConfig.config,
            usSpinnerConfig.themes[theme]);
        var spinner = new Spinner(options);
        spinner.delay = usSpinnerConfig.delay;
        lazyImage.setSpinner(spinner);
      }

      scope.$on('$destroy', function () {
        lazyImage.removeImage();
      });

      $rootScope.$on('lazyImg.runCheck', function () {
        lazyImage.checkImages();
      });

      $rootScope.$on('lazyImg:refresh', function () {
        lazyImage.checkImages();
      });
    }

    return {
      link: link,
      restrict: 'A'
    };
  }])

  /* @ngInject */
  .directive('lazyImgContainer', ["LazyImgMagic", function (LazyImgMagic) {
    'use strict';

    function link(scope, element) {
      LazyImgMagic.addContainer(element);
      scope.$on('$destroy', function () {
        LazyImgMagic.removeContainer(element);
      });
    }

    return {
      link: link,
      restrict: 'A'
    };
  }]);
